import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

import HeaderInfo from './HeaderInfo';
import ProvisioningInfo from './ProvisioningInfo';
import BodyInfo from './BodyInfo';
import '../../../styles/MemberModal.css';
import BodySubmit from './BodySubmit';
import ModifyProvisioning from './ModifyProvisioning';

export const MemberModal = (props) => {
    const [override, setOverride] = useState(false)
    const [userIsAdmin, setUserIsAdmin] = useState(false)
    const user = JSON.parse(sessionStorage.getItem("user"));

    useEffect(() => {
        CheckUserIsAdmin();
    }, [props])

    const CheckUserIsAdmin = async () => {
        const isAdmin =
            await fetch('api/admin/GetAdminRoleBySfId/' + user.sfid)
                .then(async (isAdminResponse) => {
                    try {
                        return await isAdminResponse.json()
                            .then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors);
                                return json.message;
                            });
                    }
                    catch (ex) {
                        return console.log(ex);
                    }
                })
                .catch((error) => {
                    console.log("Error getting a response: " + error);
                });
        setUserIsAdmin(isAdmin);
    }

    return (
        <Modal
            id="member-modal"
            show={props.show}
            onHide={props.onHide}
            backdrop='static'
            keyboard={false}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <HeaderInfo member={props.member} />
            </Modal.Header>
            <Modal.Body className="style-bg">
                <BodyInfo member={props.member} />
            </Modal.Body>
            <Modal.Body className="style-bg">
                <BodySubmit member={props.member} />
            </Modal.Body>
            <Modal.Body className="style-bg">
                {override && user && userIsAdmin ?
                    <ModifyProvisioning member={props.member} pass={props.member.passStatus} setOverride={() => { setOverride(false) }} isAdmin={userIsAdmin} /> :
                    <ProvisioningInfo pass={props.member.passStatus} setOverride={() => { setOverride(true) }} isAdmin={userIsAdmin} />
                }
            </Modal.Body>
        </Modal>
    );
}